export { default as DefaultLayout } from './DefaultLayout.vue';
export { default as DefaultLayout1 } from './DefaultLayout.vue';
